import { ElementRef, Injectable, OnDestroy, Renderer2 } from '@angular/core';

@Injectable()
export abstract class ApModalHelperBase<T> implements OnDestroy {
  // call from ngOnInit in component
  abstract onInit(): void;

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters -- I want to be able to specify the type here
  abstract modalData<TData>(): TData;

  // resolve the promise because the user is done and there is a successful result
  abstract emitAndClose(result: T | PromiseLike<T>): void;

  // reject the promise
  abstract dismiss(reason?: unknown): void;

  // resolve the promise because there is a successful result, but don't close the modal
  // call when closing of modal is already done elsewhere
  // THIS SHOULD ONLY BE CALLED IN VERY RARE CASES
  abstract emitWithoutClose(result: T | PromiseLike<T>): void;

  // reject the promise, but don't close the modal
  // call when closing of modal is already done elsewhere
  // THIS SHOULD ONLY BE CALLED IN VERY RARE CASES
  abstract dismissWithoutClose(reason?: unknown): void;

  abstract ngOnDestroy(): void;

  protected makeCompatibleWithBootstrapModalOnInit(_this: {
    renderer2: Renderer2;
    elementRef: ElementRef<HTMLElement>;
  }) {
    // mimic the behavior of ngx-bootstrap config for backwards compatibility,
    // so that all the current modals don't have to be refactored to work/look correctly.

    // https://github.com/valor-software/ngx-bootstrap/blob/v9.0.0/src/modal/modal-container.component.ts#L20-L37
    // TODO: We should probably take this out eventually to go more off of material standards
    // by using this: https://v15.material.angular.io/components/dialog/overview
    const element = _this.elementRef.nativeElement;
    const parent1 = element.parentElement;
    _this.renderer2.addClass(parent1, 'modal-content');
    _this.renderer2.addClass(parent1, 'ap-cdk-bootstrap-modal-override');

    const parent2 = parent1?.parentElement;
    _this.renderer2.addClass(parent2, 'modal-dialog');
    _this.renderer2.addClass(parent2, 'ap-cdk-bootstrap-modal-override');

    const parent3 = parent2?.parentElement;
    _this.renderer2.addClass(parent3, 'modal');
    _this.renderer2.addClass(parent3, 'ap-cdk-bootstrap-modal-override');
  }
}
